import { payCycle as cycleEnum } from './enum';

function mapOptions(arr) {
  return arr.map(o => ({ label: o.name, value: o.id }))
}

/**
 * 根据字段租期时长过滤支付周期选项
 * @param {object} timeRange
 * @returns {object[]}
 */
export function filterCycleOptions(value) {
  let optionsAll = mapOptions(cycleEnum);

  if (!value) return optionsAll;
  let cycleTextArr = null;
  switch (value) {
    case '1':
    case '2':
      cycleTextArr = ['月付'];
      break;
    case '3':
    case '4':
    case '5':
      cycleTextArr = ['月付', '季付'];
      break;
    case '6':
    case '7':
    case '8':
    case '9':
    case '10':
    case '11':
      cycleTextArr = ['月付', '季付', '半年付'];
      break;
    case '12':
      cycleTextArr = ['月付', '季付', '半年付', '年付'];
      break;
    default:
      cycleTextArr = ['月付', '季付', '半年付', '年付'];
      break;
  }

  return optionsAll.filter(option =>
    cycleTextArr.some(text => option.label === text)
  );
}



// WEBPACK FOOTER //
// ./src/components/forms/BusinessContractForm/strategy.js